const CustomerTypeForBuyer = [
    { name: 'Registered Owner', value: 'registered_owner' },
    { name: 'Beneficial Owner', value: 'beneficial_owner' },
    { name: 'Technical Manager', value: 'technical_manager' },
    { name: 'Charter', value: 'charter' },
    { name: 'Commercial Operator', value: 'commercial_operator' },
    { name: 'Third Party Operator', value: 'third_party_operator' },
    { name: 'ISM Manager', value: 'ISM_manager' },
    { name: 'Nominal Owner', value: 'nominal_owner' },
    { name: 'Trader', value: 'trader' },
    { name: 'Broker', value: 'broker' },
];
const CustomerTypeForSupplier = [
    { name: 'Refinery', value: 'refinery' },
    { name: 'Physical Supplier', value: 'physical_supplier' },
    { name: 'Seller', value: 'seller' },
    { name: 'Trader', value: 'trader' },
];

const VesselTypes = [
    { name: 'Asphalt Tanker', value: 'asphalt_tanker' },
    { name: 'Bulk Carrier', value: 'bulk_carrier' },
    { name: 'Bulk Ore Carrier', value: 'bulk_ore_carrier' },
    { name: 'Combined Chemical and Oil Tanker', value: 'combined_chemical_and_oil_tanker' },
    { name: 'Crude Oil Tanker', value: 'crude_oil_tanker' },
    { name: 'Diving Support', value: 'diving_support' },
    { name: 'Drill Ship', value: 'drill_ship' },
    { name: 'Dry Bulk Carrier', value: 'dry_bulk_carrier' },
    { name: 'General Cargo', value: 'general_cargo' },
    { name: 'LPG Carrier', value: 'LPG_carrier' },
    { name: 'Pontoon', value: 'pontoon' },
    { name: 'Product Tanker', value: 'product_tanker' },
    { name: 'Research / Supply ship', value: 'research_Supply_ship' },
    { name: 'Seismographic Research', value: 'seismographic_research' },
    { name: 'Supply', value: 'supply' },
    { name: 'Support', value: 'support' },
    { name: 'Tug/supply', value: 'tug_supply' },
    { name: 'Wood-Chip Carrier', value: 'wood-chip_carrier' },
];

const YesNo = [
    { name: 'Yes', value: 'yes' },
    { name: 'No', value: 'no' },
];
const TrueFalse = [
    { name: 'True', value: 'true' },
    { name: 'False', value: 'false' },
];
const YesNoTrueFalse = [
    { name: 'Yes', value: true },
    { name: 'No', value: false },
];
const VesselOwner = [
    { name: 'Registered', value: 'registered' },
    { name: 'Technical', value: 'technical' },
    { name: 'Commercial', value: 'commercial' },
];

const ProductTypes = [
    { name: 'Fuel', value: 'fuel' },
    { name: 'Fuel Oil', value: 'fuel oil' },
];

const CountryList = [
    { name: 'Afghanistan', value: 'afghanistan' },
    { name: 'Albania', value: 'albania' },
    { name: 'Algeria', value: 'algeria' },
    { name: 'Andorra', value: 'andorra' },
    { name: 'Angola', value: 'angola' },
    { name: 'Antigua and Barbuda', value: 'antigua_and_barbuda' },
    { name: 'Argentina', value: 'argentina' },
    { name: 'Armenia', value: 'armenia' },
    { name: 'Australia', value: 'australia' },
    { name: 'Austria', value: 'austria' },
    { name: 'Azerbaijan', value: 'azerbaijan' },
    { name: 'Bahamas', value: 'bahamas' },
    { name: 'Bahrain', value: 'bahrain' },
    { name: 'Bangladesh', value: 'bangladesh' },
    { name: 'Barbados', value: 'barbados' },
    { name: 'Belarus', value: 'belarus' },
    { name: 'Belgium', value: 'belgium' },
    { name: 'Belize', value: 'belize' },
    { name: 'Benin', value: 'benin' },
    { name: 'Bhutan', value: 'bhutan' },
    { name: 'Bolivia', value: 'bolivia' },
    { name: 'Bosnia and Herzegovina', value: 'bosnia_and_herzegovina' },
    { name: 'Botswana', value: 'botswana' },
    { name: 'Brazil', value: 'brazil' },
    { name: 'Brunei', value: 'brunei' },
    { name: 'Bulgaria', value: 'bulgaria' },
    { name: 'Burkina Faso', value: 'burkina_faso' },
    { name: 'Burundi', value: 'burundi' },
    { name: 'Cabo Verde', value: 'cabo_verde' },
    { name: 'Cambodia', value: 'cambodia' },
    { name: 'Cameroon', value: 'cameroon' },
    { name: 'Canada', value: 'canada' },
    { name: 'Central African Republic', value: 'central_african_republic' },
    { name: 'Chad', value: 'chad' },
    { name: 'Chile', value: 'chile' },
    { name: 'China', value: 'china' },
    { name: 'Colombia', value: 'colombia' },
    { name: 'Comoros', value: 'comoros' },
    { name: 'Congo (Congo-Brazzaville)', value: 'congo_brazzaville' },
    { name: 'Costa Rica', value: 'costa_rica' },
    { name: 'Croatia', value: 'croatia' },
    { name: 'Cuba', value: 'cuba' },
    { name: 'Cyprus', value: 'cyprus' },
    { name: 'Czechia (Czech Republic)', value: 'czech_republic' },
    { name: 'Democratic Republic of the Congo (Congo-Kinshasa)', value: 'congo_kinshasa' },
    { name: 'Denmark', value: 'denmark' },
    { name: 'Djibouti', value: 'djibouti' },
    { name: 'Dominica', value: 'dominica' },
    { name: 'Dominican Republic', value: 'dominican_republic' },
    { name: 'East Timor (Timor-Leste)', value: 'timor_leste' },
    { name: 'Ecuador', value: 'ecuador' },
    { name: 'Egypt', value: 'egypt' },
    { name: 'El Salvador', value: 'el_salvador' },
    { name: 'Equatorial Guinea', value: 'equatorial_guinea' },
    { name: 'Eritrea', value: 'eritrea' },
    { name: 'Estonia', value: 'estonia' },
    { name: 'Eswatini (fmr. "Swaziland")', value: 'eswatini' },
    { name: 'Ethiopia', value: 'ethiopia' },
    { name: 'Fiji', value: 'fiji' },
    { name: 'Finland', value: 'finland' },
    { name: 'France', value: 'france' },
    { name: 'Gabon', value: 'gabon' },
    { name: 'Gambia', value: 'gambia' },
    { name: 'Georgia', value: 'georgia' },
    { name: 'Germany', value: 'germany' },
    { name: 'Ghana', value: 'ghana' },
    { name: 'Greece', value: 'greece' },
    { name: 'Grenada', value: 'grenada' },
    { name: 'Guatemala', value: 'guatemala' },
    { name: 'Guinea', value: 'guinea' },
    { name: 'Guinea-Bissau', value: 'guinea_bissau' },
    { name: 'Guyana', value: 'guyana' },
    { name: 'Haiti', value: 'haiti' },
    { name: 'Holy See', value: 'holy_see' },
    { name: 'Honduras', value: 'honduras' },
    { name: 'Hungary', value: 'hungary' },
    { name: 'Iceland', value: 'iceland' },
    { name: 'India', value: 'india' },
    { name: 'Indonesia', value: 'indonesia' },
    { name: 'Iran', value: 'iran' },
    { name: 'Iraq', value: 'iraq' },
    { name: 'Ireland', value: 'ireland' },
    { name: 'Israel', value: 'israel' },
    { name: 'Italy', value: 'italy' },
    { name: 'Ivory Coast', value: 'ivory_coast' },
    { name: 'Jamaica', value: 'jamaica' },
    { name: 'Japan', value: 'japan' },
    { name: 'Jordan', value: 'jordan' },
    { name: 'Kazakhstan', value: 'kazakhstan' },
    { name: 'Kenya', value: 'kenya' },
    { name: 'Kiribati', value: 'kiribati' },
    { name: 'Kuwait', value: 'kuwait' },
    { name: 'Kyrgyzstan', value: 'kyrgyzstan' },
    { name: 'Laos', value: 'laos' },
    { name: 'Latvia', value: 'latvia' },
    { name: 'Lebanon', value: 'lebanon' },
    { name: 'Lesotho', value: 'lesotho' },
    { name: 'Liberia', value: 'liberia' },
    { name: 'Libya', value: 'libya' },
    { name: 'Liechtenstein', value: 'liechtenstein' },
    { name: 'Lithuania', value: 'lithuania' },
    { name: 'Luxembourg', value: 'luxembourg' },
    { name: 'Madagascar', value: 'madagascar' },
    { name: 'Malawi', value: 'malawi' },
    { name: 'Malaysia', value: 'malaysia' },
    { name: 'Maldives', value: 'maldives' },
    { name: 'Mali', value: 'mali' },
    { name: 'Malta', value: 'malta' },
    { name: 'Marshall Islands', value: 'marshall_islands' },
    { name: 'Mauritania', value: 'mauritania' },
    { name: 'Mauritius', value: 'mauritius' },
    { name: 'Mexico', value: 'mexico' },
    { name: 'Micronesia', value: 'micronesia' },
    { name: 'Moldova', value: 'moldova' },
    { name: 'Monaco', value: 'monaco' },
    { name: 'Mongolia', value: 'mongolia' },
    { name: 'Montenegro', value: 'montenegro' },
    { name: 'Morocco', value: 'morocco' },
    { name: 'Mozambique', value: 'mozambique' },
    { name: 'Myanmar (formerly Burma)', value: 'myanmar' },
    { name: 'Namibia', value: 'namibia' },
    { name: 'Nauru', value: 'nauru' },
    { name: 'Nepal', value: 'nepal' },
    { name: 'Netherlands', value: 'netherlands' },
    { name: 'New Zealand', value: 'new_zealand' },
    { name: 'Nicaragua', value: 'nicaragua' },
    { name: 'Niger', value: 'niger' },
    { name: 'Nigeria', value: 'nigeria' },
    { name: 'North Macedonia', value: 'north_macedonia' },
    { name: 'Norway', value: 'norway' },
    { name: 'Oman', value: 'oman' },
    { name: 'Pakistan', value: 'pakistan' },
    { name: 'Palau', value: 'palau' },
    { name: 'Palestine State', value: 'palestine' },
    { name: 'Panama', value: 'panama' },
    { name: 'Papua New Guinea', value: 'papua_new_guinea' },
    { name: 'Paraguay', value: 'paraguay' },
    { name: 'Peru', value: 'peru' },
    { name: 'Philippines', value: 'philippines' },
    { name: 'Poland', value: 'poland' },
    { name: 'Portugal', value: 'portugal' },
    { name: 'Qatar', value: 'qatar' },
    { name: 'Romania', value: 'romania' },
    { name: 'Russia', value: 'russia' },
    { name: 'Rwanda', value: 'rwanda' },
    { name: 'Saint Kitts and Nevis', value: 'saint_kitts_and_nevis' },
    { name: 'Saint Lucia', value: 'saint_lucia' },
    { name: 'Saint Vincent and the Grenadines', value: 'saint_vincent_and_the_grenadines' },
    { name: 'Samoa', value: 'samoa' },
    { name: 'San Marino', value: 'san_marino' },
    { name: 'Sao Tome and Principe', value: 'sao_tome_and_principe' },
    { name: 'Saudi Arabia', value: 'saudi_arabia' },
    { name: 'Senegal', value: 'senegal' },
    { name: 'Serbia', value: 'serbia' },
    { name: 'Seychelles', value: 'seychelles' },
    { name: 'Sierra Leone', value: 'sierra_leone' },
    { name: 'Singapore', value: 'singapore' },
    { name: 'Slovakia', value: 'slovakia' },
    { name: 'Slovenia', value: 'slovenia' },
    { name: 'Solomon Islands', value: 'solomon_islands' },
    { name: 'Somalia', value: 'somalia' },
    { name: 'South Africa', value: 'south_africa' },
    { name: 'South Korea', value: 'south_korea' },
    { name: 'South Sudan', value: 'south_sudan' },
    { name: 'Spain', value: 'spain' },
    { name: 'Sri Lanka', value: 'sri_lanka' },
    { name: 'Sudan', value: 'sudan' },
    { name: 'Suriname', value: 'suriname' },
    { name: 'Sweden', value: 'sweden' },
    { name: 'Switzerland', value: 'switzerland' },
    { name: 'Syria', value: 'syria' },
    { name: 'Tajikistan', value: 'tajikistan' },
    { name: 'Tanzania', value: 'tanzania' },
    { name: 'Thailand', value: 'thailand' },
    { name: 'Togo', value: 'togo' },
    { name: 'Tonga', value: 'tonga' },
    { name: 'Trinidad and Tobago', value: 'trinidad_and_tobago' },
    { name: 'Tunisia', value: 'tunisia' },
    { name: 'Turkey', value: 'turkey' },
    { name: 'Turkmenistan', value: 'turkmenistan' },
    { name: 'Tuvalu', value: 'tuvalu' },
    { name: 'Uganda', value: 'uganda' },
    { name: 'Ukraine', value: 'ukraine' },
    { name: 'United Arab Emirates', value: 'united_arab_emirates' },
    { name: 'United Kingdom', value: 'united_kingdom' },
    { name: 'Uruguay', value: 'uruguay' },
    { name: 'Uzbekistan', value: 'uzbekistan' },
    { name: 'Vanuatu', value: 'vanuatu' },
    { name: 'Vatican City', value: 'vatican_city' },
    { name: 'Venezuela', value: 'venezuela' },
    { name: 'Vietnam', value: 'vietnam' },
    { name: 'Yemen', value: 'yemen' },
    { name: 'Zambia', value: 'zambia' },
    { name: 'Zimbabwe', value: 'zimbabwe' },
];

const FacilityTypes = [
    { name: 'Buyer Credit', value: 'buyer_credit' },
    { name: 'Supplier Credit', value: 'supplier_credit' },
    { name: 'Spot Credit', value: 'spot_credit' },
    { name: 'Trade Support', value: 'early_payment' },
    { name: 'Investor', value: 'investor' },
    { name: 'Junior Tranche', value: 'junior_tranche' },
    { name: 'Working Capital', value: 'sf_working_capital' },
    { name: 'Master Investor', value: 'master_investor' },
    { name: 'Master Spot Credit', value: 'master_spot' },
];
const Status = [
    { name: 'Active', value: 'active' },
    { name: 'Draft', value: 'draft' },
];

const CreditRating = [
    { name: 'SF1', value: 'SF1' },
    { name: 'SF2', value: 'SF2' },
    { name: 'SF3', value: 'SF3' },
    { name: 'SF4', value: 'SF4' },
    { name: 'SF5', value: 'SF5' },
    { name: 'SF6', value: 'SF6' },
];
const MinInvestmentPeroid = [
    { name: '3 Months', value: '3_months' },
    { name: '6 Months', value: '6_months' },
    { name: '9 Months', value: '9_months' },
    { name: '12 Months', value: '12_months' },
];
const RiskPreference = [
    { name: 'Low', value: 'low' },
    { name: 'Low - Medium', value: 'low_medium' },
    { name: 'Medium - High', value: 'medium_high' },
    { name: 'High', value: 'high' },
];
const SanctionCheckList = [
    { value: 'green', name: 'Green' },
    { value: 'amber', name: 'Amber' },
    { value: 'red', name: 'Red' },
];

const DeliveryCharges = [
    { name: 'VAT', value: 'vat' },
    { name: 'HANDLING FEE', value: 'handling_fee' },
    { name: 'CANCELLATION FEE', value: 'cancellation_fee' },
    { name: 'ANCHORAGE FEE', value: 'anchorage_fee' },
    { name: 'AGENCY FEE', value: 'agency_fee' },
    { name: 'PROFESSIONAL FEE', value: 'professional_fee' },
    { name: 'BROKERAGE FEE - PRODUCT WISE', value: 'brokerage_fee_product_wise' },
    { name: 'BROKERAGE FEE -  LUMP SUM', value: 'brokerage_fee_lump_sum' },
    { name: 'BARGING FEE - PRODUCT WISE', value: 'barging_fee_product_wise' },
    { name: 'BARGING FEE -  LUMP SUM', value: 'barging_fee_lump_sum' },
    { name: 'TRUCKING FEE - PRODUCT WISE', value: 'trucking_fee_product_wise' },
    { name: 'TRUCKING FEE - LUMP SUM', value: 'trucking_fee_lump_sum' },
    { name: 'Other (Please Specify)', value: 'other' },
];

const DeliveryChargesWithOneProduct = [
    { name: 'VAT', value: 'vat' },
    { name: 'HANDLING FEE', value: 'handling_fee' },
    { name: 'CANCELLATION FEE', value: 'cancellation_fee' },
    { name: 'ANCHORAGE FEE', value: 'anchorage_fee' },
    { name: 'AGENCY FEE', value: 'agency_fee' },
    { name: 'PROFESSIONAL FEE', value: 'professional_fee' },
    { name: 'BROKERAGE FEE', value: 'brokerage_fee_lump_sum' },
    { name: 'BARGING FEE', value: 'barging_fee_lump_sum' },
    { name: 'TRUCKING FEE', value: 'trucking_fee_lump_sum' },
    { name: 'Other (Please Specify)', value: 'other' },
];

const FeeTypesForBuyer = [
    { name: 'Dispute Claim Management Fees', value: 'dispute_claim_management_fees' },
    { name: 'Broker Risk Premium', value: 'broker_risk_premium' },
    { name: 'Dispute management service fees', value: 'dispute_management_service_fees' },
    { name: 'Engagement Fees', value: 'engagement_fees' },
    { name: 'Handling Fees', value: 'handling_fees' },
    { name: 'Late Payment Fees', value: 'late_payment_fees' },
    { name: 'Platform Fees', value: 'platform_fees' },
    { name: 'Processing Support Fees', value: 'processing_support_fees' },
    { name: 'Spot Fees', value: 'spot_fees' },
    { name: 'Trade acceleration charges', value: 'trade_acceleration_charges' },
    { name: 'Trade Ops Service Fees', value: 'trade_ops_service_fees' },
    { name: 'Other Fees', value: 'other_fees' },
];

const FeeTypesForSupplier = [
    { name: 'Trade margin fees', value: 'early_payment_fees' },
    // { name: 'Discount Percentage Fees', value: 'discount_percentage_fees' },
    { name: 'Engagement Fees', value: 'engagement_fees' },
    { name: 'Handling Fees', value: 'handling_fees' },
    { name: 'Late payment fees', value: 'late_payment_fees' },
    { name: 'Platform Fees', value: 'platform_fees' },
    { name: 'Processing Support Fees', value: 'processing_support_fees' },
    // { name: 'Trade acceleration charges', value: 'trade_acceleration_charges' },
    { name: 'Other Fees', value: 'other_fees' },
];

const FeeMethods = [
    { name: 'Lumpsum', value: 'lumpsum' },
    { name: ' Per MT', value: 'per_mt' },
    { name: 'Percentage', value: 'percentage' },
    { name: 'SOFR + Margin', value: 'sofr_margin' },
];
const FeeFrequency = [{ name: 'Per Deal', value: 'per_deal' }];
const FeeMethodsForCreditOrExtended = [
    { name: 'Percentage', value: 'percentage' },
    { name: 'SOFR + Margin', value: 'sofr_margin' },
];
const ComplianceRiskLevel = [
    { value: 'Sanctioned', name: 'Sanctioned' },
    { value: 'High', name: 'High' },
    { value: 'Moderate', name: 'Moderate' },
    { value: 'Low', name: 'Low' },
];

export const DropdownConstants = {
    VesselTypes: VesselTypes,
    CountryList: CountryList,
    YesNo: YesNo,
    TrueFalse: TrueFalse,
    VesselOwner: VesselOwner,
    ProductTypes: ProductTypes,
    CustomerTypeForBuyer: CustomerTypeForBuyer,
    CustomerTypeForSupplier: CustomerTypeForSupplier,
    FacilityTypes: FacilityTypes,
    Status: Status,
    CreditRating: CreditRating,
    MinInvestmentPeroid: MinInvestmentPeroid,
    RiskPreference: RiskPreference,
    SanctionCheckList: SanctionCheckList,
    DeliveryCharges: DeliveryCharges,
    DeliveryChargesWithOneProduct: DeliveryChargesWithOneProduct,
    FeeTypesForBuyer: FeeTypesForBuyer,
    FeeTypesForSupplier: FeeTypesForSupplier,
    FeeMethods: FeeMethods,
    FeeFrequency: FeeFrequency,
    FeeMethodsForCreditOrExtended: FeeMethodsForCreditOrExtended,
    ComplianceRiskLevel: ComplianceRiskLevel,
    YesNoTrueFalse
};
